import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { cn } from "../../lib/cn";
/** Light teal wash – PageTest brand */
const CTA_GRADIENT_MOBILE =
  "linear-gradient(to top, hsl(173_35%_58%)_0%, hsl(173_28%_84%)_38%, hsl(173_22%_96%)_72%, hsl(0_0%_100%)_100%)";
const CTA_GRADIENT_DESKTOP =
  "linear-gradient(to left, hsl(173_35%_58%)_0%, hsl(173_28%_84%)_42%, hsl(173_22%_96%)_76%, hsl(0_0%_100%)_100%)";

export function HomeBottomCta() {
  const sectionRef = useRef(null);
  const [boltActive, setBoltActive] = useState(false);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    if (prefersReducedMotion) {
      setBoltActive(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setBoltActive(true);
          observer.disconnect();
        }
      },
      { threshold: 0.4, rootMargin: "0px 0px -8% 0px" },
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="pt-16 sm:pt-20 pb-0"
      aria-labelledby="home-cta-heading"
    >      <div className="relative overflow-hidden rounded-2xl border border-border bg-card text-foreground shadow-sm">
        <div
          className="pointer-events-none absolute inset-0 md:hidden"
          style={{ background: CTA_GRADIENT_MOBILE }}
          aria-hidden
        />
        <div
          className="pointer-events-none absolute inset-0 hidden md:block"
          style={{ background: CTA_GRADIENT_DESKTOP }}
          aria-hidden
        />
        <img
          src="/logo.svg"
          alt=""
          width={64}
          height={64}
          className="absolute top-6 right-6 z-10 h-14 w-14 md:hidden"
          aria-hidden
        />

        <img
          src="/logo.svg"
          alt=""
          width={144}
          height={144}
          className={cn(
            "home-cta-bolt pointer-events-none absolute top-1/2 right-8 z-10 hidden h-28 w-28 md:block lg:right-12 lg:h-36 lg:w-36",
            boltActive && "home-cta-bolt--active",
          )}
          aria-hidden
        />
        <div className="relative grid grid-cols-1 items-center gap-0 px-8 pt-8 pb-6 sm:px-10 sm:pt-10 sm:pb-7 md:grid-cols-2 md:gap-8 lg:grid-cols-[1fr_auto] lg:gap-12 lg:px-12 lg:pt-12 lg:pb-10">
          <div className="text-left pr-16 md:pr-0">
            <h2
              id="home-cta-heading"
              className="text-3xl sm:text-4xl lg:text-[2.75rem] font-[450] tracking-[-0.06em] leading-[1.05] text-balance text-foreground"
            >
              Measure before you ship
            </h2>
            <Link
              to="/test"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-foreground px-7 py-2.5 text-sm font-medium text-background hover:bg-foreground/90 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-card"
            >
              Run Test
              <ArrowRight size={16} aria-hidden />
            </Link>
          </div>

          <div
            className="relative hidden min-h-28 md:block lg:min-h-36"
            aria-hidden
          />
        </div>
      </div>
    </section>
  );
}
